import { Search, SentimentDissatisfied } from "@mui/icons-material";
import {
  CircularProgress,
  Grid,
  InputAdornment,
  TextField,
  Button,
} from "@mui/material";
import { Box } from "@mui/system";
import axios from "axios";
import { useSnackbar } from "notistack";
import React, { useEffect, useState } from "react";
import { config } from "../App";
import Footer from "./Footer";
import Header from "./Header";
import "./Products.css";
import ProductCard from "./ProductCard";
import { Troubleshoot } from "@mui/icons-material";
import Cart, { generateCartItemsFrom } from "./Cart";
import { ArrowForwardIosTwoTone } from "@mui/icons-material";
// Definition of Data Structures used
/**
 * @typedef {Object} Product - Data on product available to buy
 * 
 * @property {string} name - The name or title of the product


/**
 * @typedef {Object} CartItem -  - Data on product added to cart
 * 
 * @property {string} name - The name or title of the product in cart
 * @property {string} qty - The quantity of product added to cart
 * @property {string} category - The category that the product belongs to
 * @property {number} cost - The price to buy the product
 * @property {number} rating - The aggregate rating of the product (integer out of five)
 * @property {string} image - Contains URL for the product image
 * @property {string} _id - Unique ID for the product
 */


const Products = () => {

  const {enqueueSnackbar} = useSnackbar();
const [circularLoader, setCircularLoader] = useState(false);
const [productarr, setProductarr] = useState([]);
const [productNotFound, setProductNotFound] = useState(false);
const [searchtimerout, setSearchTimerOut] =useState("");
const [usertoken, setUserToken] = useState();
const [userCartProductsidqty, setUserCartProductsidqty] = useState([]);
const [userCartProductsAllInfo, setUserCartProductsAllInfo] = useState([]);
let token = localStorage.getItem('token');
  // TODO: CRIO_TASK_MODULE_PRODUCTS - Fetch products data and store it
  /**
   * Make API call to get the products list and store it to display the products
   *
   * @returns { Array.<Product> }
   *      Array of objects with complete data on all available products
   *
   * API endpoint - "GET /products"
   *
   * Example for successful response from backend:
   * HTTP 200
   * [
   *      {
   *          "name": "iPhone XR",
   *          "category": "Phones",
   *          "cost": 100,
   *          "rating": 4,
   *          "image": "https://i.imgur.com/lulqWzW.jpg",
   *          "_id": "v4sLtEcMpzabRyfx"
   *      },
   *      {
   *          "name": "Basketball",
   *          "category": "Sports",
   *          "cost": 100,
   *          "rating": 5,
   *          "image": "https://i.imgur.com/lulqWzW.jpg",
   *          "_id": "upLK9JbQ4rMhTwt4"
   *      }
   * ]
   *
   * Example for failed response from backend:
   * HTTP 500
   * {
   *      "success": false,
   *      "message": "Something went wrong. Check the backend console for more details"
   * }
   */
  const performAPICall = async () => {
      setCircularLoader(true);
      try{
        const response = await axios.get(`${config.endpoint}/products`);        
        // console.log(response);        
          setProductarr(response.data);          
          setCircularLoader(false);
          //console.log("response product data", response);
          // console.log("Use state circular loader", circularLoader);
          // console.log("Use state productarray", productarr);
         // console.log("Response product data", productarr);
         // enqueueSnackbar(`item already in cart`, {variant:"success"});        
        return response.data;
      }
      catch(err){
        setCircularLoader(false);
        if(err.response&& err.response.status===500)
        {
          enqueueSnackbar(err.response.data.message, {variant:"error"});
        }
        else{
          enqueueSnackbar("Something went wrong. Check that the backend is running, reachable and returns valid JSON.",{variant:"error"});
        }        
      }
  };
  

  // TODO: CRIO_TASK_MODULE_PRODUCTS - Implement search logic
  /**
   * Definition for search handler
   * This is the function that is called on adding new search keys
   *
   * @param {string} text
   *    Text user types in the search bar. To filter the displayed products based on this text.
   *
   * @returns { Array.<Product> }
   *      Array of objects with complete data on filtered set of products
   *
   * API endpoint - "GET /products/search?value=<search-query>"
   *
   */
  const performSearch = async (text) => {
      try{
            const filteredproducts = await axios.get(`${config.endpoint}/products/search?value=${text}`);
            if(filteredproducts.data){
              setProductNotFound(false);
              setProductarr(filteredproducts.data);
              return filteredproducts.data;
            }
      // console.log("filtered products", filteredproducts.data);
            
      }catch(error){
          setProductNotFound(true);
          enqueueSnackbar(`error ${error.response.data.message}`, {variant:"error"});
      }
  };


  
  // TODO: CRIO_TASK_MODULE_PRODUCTS - Optimise API calls with debounce search implementation
  /**
   * Definition for debounce handler
   * With debounce, this is the function to be called whenever the user types text in the searchbar field
   *
   * @param {{ target: { value: string } }} event
   *    JS event object emitted from the search input field
   *
   * @param {NodeJS.Timeout} debounceTimeout
   *    Timer id set for the previous debounce call
   *
   */
  const debounceSearch = (event, debounceTimeout) => {
      clearTimeout(debounceTimeout);
      let searchtimer = setTimeout(()=> performSearch(event), 500);
      setSearchTimerOut(searchtimer);
  };



  
  


  /**
   * Perform the API call to fetch the user's cart and return the response
   *
   * @param {string} token - Authentication token returned on login
   *
   * @returns { Array.<{ productId: string, qty: number }> | null }
   *    The response JSON object
   *
   * Example for successful response from backend:
   * HTTP 200
   * [
   *      {
   *          "productId": "KCRwjF7lN97HnEaY",
   *          "qty": 3
   *      },
   *      {
   *          "productId": "BW0jAAeDJmlZCF8i",
   *          "qty": 1
   *      }
   * ]
   *
   * Example for failed response from backend:
   * HTTP 401
   * {
   *      "success": false,
   *      "message": "Protected route, Oauth2 Bearer token not found"
   * }
   */
  const fetchCart = async (token) => {
    // let mytoken = localStorage.getItem("token");
    // console.log("fetchcart local mytoken",mytoken);
   // console.log("fetchcart token parameter",token);
    if (!token) return;
    try {
      // TODO: CRIO_TASK_MODULE_CART - Pass Bearer token inside "Authorization" header to get data from "GET /cart" API and return the response data
      const headertoken = {'Authorization' : `Bearer ${token}`}  
      const cartresponse = await axios.get(`${config.endpoint}/cart`, {headers: headertoken});
      //console.log("cartresponse fetchcart",cartresponse.data);
      
      return cartresponse.data;
    } catch (e) {
      if (e.response && e.response.status === 400) {
        enqueueSnackbar(e.response.data.message, { variant: "error" });
      } else {
        enqueueSnackbar(
          "Could not fetch cart details. Check that the backend is running, reachable and returns valid JSON.",
          {
            variant: "error",
          }
        );
      }
      return null;
    }
  };

  
  // const printarr =  () => {
  //     console.log("user cart data",userCartProductsAllInfo);

  // }



  const fetchproductCartdata = async () => {
    const loadproduct
    
    = await performAPICall();
    //console.log("loadproduct in fetchproductCartdata", loadproduct);
    if(token)
    setUserToken(token);
    const cartProducts = await fetchCart(token);
    //console.log("cartProducts in fetchproductCartdata", cartProducts);
    setUserCartProductsidqty(cartProducts);
    //console.log("userCartProductsidqty in fetchproductCartdata", userCartProductsidqty);
    const cartProductsAllInfo = await generateCartItemsFrom(cartProducts, loadproduct);

    //console.log("cartProductsAllInfo in fetchproductCartdata", cartProductsAllInfo)
    
    setUserCartProductsAllInfo(cartProductsAllInfo);    
   }
  // TODO: CRIO_TASK_MODULE_CART - Return if a product already exists in the cart
  /**
   * Return if a product already is present in the cart
   *
   * @param { Array.<{ productId: String, quantity: Number }> } items
   *    Array of objects with productId and quantity of products in cart
   * @param { String } productId
   *    Id of a product to be checked
   *
   * @returns { Boolean }
   *    Whether a product of given "productId" exists in the "items" array
   *
   */
   
   

  const isItemInCart = (items, productId) => {
    //console.log("items in isItemInCart function: ",items);
    //console.log(productId);

    
    const ispresent = items.map((item)=>
    {
     //console.log("in isitemincart product id",productId);
      if(item.productId===productId){
        return true;
      }
      
    })
    //console.log("ispresent includes result in isItemInCart function: ",ispresent.includes(true));
    return ispresent.includes(true);    
  };

  /**
   * Perform the API call to add or update items in the user's cart and update local cart data to display the latest cart
   *
   * @param {string} token
   *    Authentication token returned on login
   * @param { Array.<{ productId: String, quantity: Number }> } items
   *    Array of objects with productId and quantity of products in cart
   * @param { Array.<Product> } products
   *    Array of objects with complete data on all available products
   * @param {string} productId
   *    ID of the product that is to be added or updated in cart
   * @param {number} qty
   *    How many of the product should be in the cart
   * @param {boolean} options
   *    If this function was triggered from the product card's "Add to Cart" button
   *
   * Example for successful response from backend:
   * HTTP 200 - Updated list of cart items
   * [
   *      {
   *          "productId": "KCRwjF7lN97HnEaY",
   *          "qty": 3
   *      },
   *      {
   *          "productId": "BW0jAAeDJmlZCF8i",
   *          "qty": 1
   *      }
   * ]
   *
   * Example for failed response from backend:
   * HTTP 404 - On invalid productId
   * {
   *      "success": false,
   *      "message": "Product doesn't exist"
   * }
   */
  const addToCart = async (
    token,
    items,
    products,
    productId,
    qty,
    options = { preventDuplicate: false }
  ) => {
    if(!token){
      enqueueSnackbar("Login to add an item to the Cart", {variant:"warning"});
      return;
    }
    if(options.preventDuplicate && isItemInCart(items, productId)){
      enqueueSnackbar("Item already in cart. Use the cart sidebar to update quantity or remove item", {variant:"warning"});
      return;
    }
    try{
      const addedproduct = await axios.post(`${config.endpoint}/cart`,
      {productId,qty },
      {headers: {'Authorization': `Bearer ${token}`} });

      //console.log("addedproduct",addedproduct)
      const cartItemsadded = await generateCartItemsFrom(addedproduct.data, products);
      setUserCartProductsAllInfo(cartItemsadded);
    }catch(e){
      if(e.response){
        enqueueSnackbar("e.response.data.message", {variant: "error"});
      }else{
        enqueueSnackbar("Something went wrong, check backend server running", {variant:"error"});
      }
    }
  };


  useEffect(() => fetchproductCartdata(), []);
  //useEffect(generateCartItemsFrom(userCartProductsAllInfo, productarr), [userCartProductsAllInfo]);



  return (
    <div>
      <Header hasHiddenAuthButtons={false}>
      <TextField size="small" className="search-desktop" 
      onChange={(e)=>{debounceSearch(e.target.value, searchtimerout)}}
      placeholder="Search for items/categories" 
      InputProps={{endAdornment:(<InputAdornment position="end">
          <Search color="primary"/>
        </InputAdornment>),  }} />        
      </Header>
      <TextField size="small" className="search-mobile" fullWidth 
      placeholder="Search for items/categories"
      onChange={(e)=>{debounceSearch(e.target.value, searchtimerout)}} 
      InputProps={{endAdornment:(<InputAdornment position="end">
          <Search color="primary"/>
        </InputAdornment>),  }} />
       <Grid container>
         <Grid item className="product-grid">
           <Box className="hero">
             <p className="hero-heading">
               India’s <span className="hero-highlight">FASTEST DELIVERY</span>{" "}
               to your door step
             </p>
           </Box>           
         </Grid> 
         {circularLoader?(<div className={"loading"}>
          <CircularProgress /><p>Loading Products</p></div>):
          !productNotFound?<>{
            token?
         (<Grid container>
         <Grid container md={9} xs={12} spacing={2} sx={{ p:2 }}>
          {productarr.map((product)=>{
             return <Grid item md={3} xs={6}> 
             <ProductCard 
             product={product}
             handleAddToCart={(e)=>addToCart(token, userCartProductsidqty, productarr, product._id, 1, {preventDuplicate: true})}             
             />           
            </Grid>         
           })}             
           </Grid>
            <Grid container sm={12} xs={12} md={3} sx={{backgroundColor:"#E9F5E1"}}>
              <Cart products={productarr} items={userCartProductsAllInfo}   
               handleQuantity={addToCart}
              />
            </Grid>
           </Grid>
           )           
           :(<Grid container spacing={2} sx={{ p:2 }}>
          {productarr.map((product)=>{
             return <Grid item md={3} xs={6} key={product._id}> 
             <ProductCard product={product} handleAddToCart={(e)=>addToCart(token, userCartProductsidqty, productarr, product._id, 1, {preventDuplicate: true})} />           
            </Grid> 
          })}             
           </Grid>)}</>:
          <Grid>
          <div className={"loading"}>
            <SentimentDissatisfied />
            <h3>No products found</h3>
            </div>
            </Grid>
            }
       </Grid>
      <Footer />
    </div>
  );
};

export default Products;
